import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCPVClass } from '../models/TypeCPVClass';

@Component({
    selector: 'app-typeCPV-class',
    templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

    @Input() uid = '';
    public current_uid = 'TypeCPVClass';
    @Input() parentForm: FormGroup;
    @Input() typeCPVClass: TypeCPVClass;

    constructor() {
    }

    public ngOnInit() {
    }

    public addclassSupplementaire() {
        this.typeCPVClass.classSupplementaire.push('ClassSupplementaire');
    }

    public removeclassSupplementaire(i) {
        this.typeCPVClass.classSupplementaire.splice(i, 1);
    }

    public getUid() {
        return this.uid + '_SepSep_' + this.current_uid;
    }
}
